import { render } from "./IconArrowDown.vue?vue&type=template&id=4cdf675d&scoped=true"
import script from "./IconArrowDown.vue?vue&type=script&lang=js"
export * from "./IconArrowDown.vue?vue&type=script&lang=js"

import "./IconArrowDown.vue?vue&type=style&index=0&id=4cdf675d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdf675d"]])

export default __exports__